import React from "react";
import { Button } from "primereact/button";
import PropTypes from "prop-types";
import "./style.scss";

export default function CustomeButton(props) {
  const { className = "", loading, variant, icon, disabled, ...rest } = props;

  const variantClass =
    {
      contained: "access-btn",
      remove: "remove-btn",
      "no-outlined": "no-outlined-btn",
      outlined: "cancel-btn",
    }[variant] || "cancel-btn";

  return (
    <Button
      {...rest}
      className={`${className} ${variantClass}`.trim()}
      icon={loading ? "pi pi-spin pi-spinner" : icon}
      disabled={disabled}
    />
  );
}

CustomeButton.propTypes = {
  label: PropTypes.string,
  loading: PropTypes.bool,
  className: PropTypes.string,
  icon: PropTypes.string,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(["contained", "remove", "outlined", "no-outlined"]),
};
